import { Logo } from '../components/Logo'
import styled from 'styled-components';
import { Aco } from '../components/Aco';

const data = [
  {en: 'Alpha-pinene' ,value:'11.50%'},
  {en: 'Camphene' ,value:'0.04%'},
  {en: 'Beta-pinene' ,value:'0.38%'},
  {en: 'Mycene' ,value:'0.52%'},
  {en: 'Alpha-phellandrene' ,value:'0.64%'},
  {en: 'Alpha-terpinene' ,value:'0.16%'},
  {en: 'p-cymene' ,value:'3.94%'},
  {en: 'limonene' ,value:'5.61%'},
  {en: '1,8-cineole' ,value:'72.54%'},
  {en: 'Trans-beta-ocimene' ,value:'0.06%'},
  {en: 'Terpinolene' ,value:'1.33%'},
  {en: 'Tras-pinocarveol' ,value:'0.06%'},
  {en: 'Terpinene-4-ol' ,value:'0.22%'},
  {en: 'Cryptone' ,value:'0.09%'},
  {en: 'Alpha-terpineol' ,value:'1.02%'},
  {en: 'Citronellol' ,value:'0.04%'},
  {en: 'Alpha-terpinyl acetate' ,value:'0.09%'},
  {en: 'Aromadendrene' ,value:'0.80%'},
  {en: 'Globulol' ,value:'0.20%'},
]

const Layout = styled.div`
  text-align: left;
  display: inline-block;
  padding: 20px;
`

const LogLayout = styled.div`
  text-align: center;
  margin: 60px 0;
`

const LeftLayout = styled.div`
  float: left;
  padding: 0 0 40px 0;
  @media screen and (min-width:960px) {
    width: 545px;
  }
`

const RightLayout = styled(LeftLayout)`
  @media screen and (min-width:960px) {
    margin: 0 0 0 40px;
    width: 335px;
  }
`

const NumberData = styled.td`
  text-align: right;
`

const detail = [
  {title: '原産国', value: 'スペイン'},
  {title: '抽出部位', value: '葉'},
  {title: '抽出方法', value: '水蒸気蒸留法'},
  {title: '学名', value: 'Eucalyptus globulus'},
]

export const EucalyptusGlobulus = () => <Layout>
<LogLayout><Logo /></LogLayout>
<LeftLayout>
<h2>使用期限</h2>
<p>{new Date('2025-03-01T09:00:00.000Z').toLocaleDateString()}</p>
<table>
  <tbody>
    {detail.map((item, index) => <tr key={index}>
      <th>{item.title}</th><td>{item.value}</td>
    </tr>)}
  </tbody>
</table>

<h3>1. PRODUCT IDENTIFICATION AND COMPOSITION</h3>
<ul>
<li>1.1 Product Name: Eucalyptus globulus Oil-100% Organic ACO</li>
<li>1.2 Botanical Name: Eucalyptus globulus TEST SPECIFICATION RESULT</li></ul>
<h3>2. PHYSICAL AND CHEMICAL PROPERTIES</h3>
<ul>
<li>2.1 Appearance: Clear, mobile liquid</li>
<li>2.2 Odour: Characteristic</li>
<li>2.3 Specific Gravity: 0.900 to 0.9250 @ 20°C Conforms</li>
<li>2.4 Refractive Index: 1.4580 to 1.4650 @ 20°C Conforms</li>
</ul>

<table>
  <tbody>
    {data.map((item, index) => <tr key={index}>
      <th>{item.en}</th><NumberData>{item.value}</NumberData>
    </tr>)}
  </tbody>
</table>
</LeftLayout>
<RightLayout>
  <Aco />
</RightLayout>
</Layout>




